/**
 * Logout: DELETE /api/session, clear cached session, bounce to /login.
 */

import { useNavigate } from "react-router-dom";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { LogOut } from "lucide-react";

import { logout as apiLogout } from "@/api/client";
import { queryKeys } from "@/api/hooks";
import { Button } from "@/components/ui/button";
import { Spinner } from "@/components/ui/spinner";
import { useSelection } from "@/store/selection";
import { useTouchCart } from "@/store/touchCart";
import { useFilters } from "@/store/filters";

export function LogoutButton() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: () => apiLogout(),
    onSettled: () => {
      queryClient.setQueryData(queryKeys.session, undefined);
      queryClient.clear();
      // Wipe account-scoped client state so the next login in this tab doesn't
      // inherit the previous user's selection, touch cart or filters (Xfe-4).
      useSelection.getState().clear();
      useTouchCart.getState().reset();
      useFilters.getState().clearFilters();
      navigate("/login", { replace: true });
    },
  });

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={() => mutation.mutate()}
      disabled={mutation.isPending}
      title="Выйти"
    >
      {mutation.isPending ? <Spinner /> : <LogOut className="h-4 w-4" />}
      Выйти
    </Button>
  );
}
